/* ==========================================================================
   KBS Favorites - zentraler Store (v2)
   Speichert Produkt-IDs in localStorage, Sync ins Kundenkonto ueber den
   Shopify App Proxy (/apps/favs -> Cloudflare Worker kbs-favs).
   API: window.KBSFavs.{list,ids,has,add,remove,toggle,clear,count,subscribe}
   Event: document -> 'kbs:favs:changed'  detail = { items, ids, count }
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'kbs_favs_v1';
  var EVT = 'kbs:favs:changed';
  var MAX = 300;
  var SYNC_DELAY = 1500;

  var cfg = window.KBS_FAVS_CONFIG || {};
  var state = [];
  var syncTimer = null;
  var ready = false;

  /* ---------- Storage-Helfer (Safari Private Mode sicher) ---------------- */

  function isValid(item) {
    return item && typeof item.id === 'number' && item.id > 0;
  }

  function readLocal() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(isValid) : [];
    } catch (e) {
      return [];
    }
  }

  function writeLocal() {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {
      /* Quota oder Private Mode: Store lebt dann nur fuer diese Session */
    }
  }

  /* ---------- Merge Konto <-> lokal ------------------------------------- */

  function normalizeServer(raw) {
    if (!raw) return [];
    var arr = raw;
    if (typeof raw === 'string') {
      try { arr = JSON.parse(raw); } catch (e) { return []; }
    }
    if (!Array.isArray(arr)) return [];
    return arr.map(function (entry) {
      if (typeof entry === 'number') return { id: entry, h: '', t: 0 };
      if (entry && typeof entry === 'object') {
        return {
          id: parseInt(entry.id, 10),
          h: typeof entry.h === 'string' ? entry.h : '',
          t: typeof entry.t === 'number' ? entry.t : 0
        };
      }
      return null;
    }).filter(isValid);
  }

  function mergeInto(incoming) {
    var seen = {};
    var merged = [];
    state.concat(incoming).forEach(function (item) {
      if (!isValid(item)) return;
      var existing = seen[item.id];
      if (existing) {
        if (item.t > existing.t) existing.t = item.t;
        if (!existing.h && item.h) existing.h = item.h;
        return;
      }
      var copy = { id: item.id, h: item.h || '', t: item.t || 0 };
      seen[item.id] = copy;
      merged.push(copy);
    });
    merged.sort(function (a, b) { return b.t - a.t; });
    state = merged.slice(0, MAX);
  }

  /* ---------- Sync ins Kundenkonto --------------------------------------
     Bewusst XMLHttpRequest statt fetch: window.fetch wird in diesem Theme
     von einer Drittanbieter-App ueberschrieben (dasselbe Problem wie beim
     filterdata-Feed des Custom-Filters). XHR ist davon nicht betroffen.

     Der Body enthaelt NUR die Liste. Die Kunden-ID wird bewusst nicht
     mitgeschickt: Shopify haengt sie beim App Proxy serverseitig als
     logged_in_customer_id an die Query, und genau die nimmt der Worker.
     Eine ID aus dem Body waere frei erfindbar. */

  function queueSync() {
    if (!cfg.customerId || !cfg.syncUrl) return;
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(pushSync, SYNC_DELAY);
  }

  function pushSync() {
    syncTimer = null;
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', cfg.syncUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({ favorites: state }));
    } catch (e) {
      /* Sync ist best effort - der lokale Store bleibt in jedem Fall gueltig */
    }
  }

  /* ---------- Events ----------------------------------------------------- */

  function ids() {
    return state.map(function (item) { return item.id; });
  }

  function emit() {
    var detail = { items: state.slice(), ids: ids(), count: state.length };
    document.dispatchEvent(new CustomEvent(EVT, { detail: detail, bubbles: true }));
  }

  function commit(sync) {
    writeLocal();
    emit();
    if (sync !== false) queueSync();
  }

  /* ---------- Oeffentliche API ------------------------------------------ */

  var api = {
    ready: function () { return ready; },

    list: function () { return state.slice(); },

    ids: ids,

    count: function () { return state.length; },

    has: function (id) {
      id = parseInt(id, 10);
      return state.some(function (item) { return item.id === id; });
    },

    add: function (id, handle) {
      id = parseInt(id, 10);
      if (!id || api.has(id)) return false;
      state.unshift({ id: id, h: handle || '', t: Date.now() });
      if (state.length > MAX) state.length = MAX;
      commit();
      return true;
    },

    remove: function (id) {
      id = parseInt(id, 10);
      var before = state.length;
      state = state.filter(function (item) { return item.id !== id; });
      if (state.length === before) return false;
      commit();
      return true;
    },

    toggle: function (id, handle) {
      if (api.has(id)) { api.remove(id); return false; }
      api.add(id, handle);
      return true;
    },

    clear: function () {
      if (!state.length) return false;
      state = [];
      commit();
      return true;
    },

    subscribe: function (fn) {
      document.addEventListener(EVT, fn);
      if (ready) fn({ detail: { items: state.slice(), ids: ids(), count: state.length } });
      return function () { document.removeEventListener(EVT, fn); };
    }
  };

  /* ---------- Init -------------------------------------------------------

     Beim Seitenaufbau wird der Kontostand aus dem Metafeld mit dem lokalen
     Stand vereinigt und anschliessend zurueckgeschrieben, falls sich beide
     unterscheiden.

     Der Vergleich laeuft ueber sortierte ID-Listen und NICHT ueber die
     Laengen. Frueher wurde nur gepusht, wenn das Konto bereits Favoriten
     hatte - ein Gast, der zehn Sets merkt und sich danach zum ersten Mal
     anmeldet, hat aber ein leeres Metafeld. Seine Liste waere erst beim
     naechsten Herzklick hochgeschoben worden, also genau im haeufigsten
     Fall zu spaet. */

  state = readLocal();

  if (cfg.customerId) {
    var serverFavs = normalizeServer(cfg.serverFavorites);

    if (serverFavs.length) {
      mergeInto(serverFavs);
      writeLocal();
    }

    var serverKey = serverFavs.map(function (i) { return i.id; }).sort().join(',');
    var localKey = ids().sort().join(',');
    if (localKey !== serverKey) queueSync();
  }

  /* Tab-uebergreifende Synchronisation */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    state = readLocal();
    emit();
  });

  window.KBSFavs = api;
  ready = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', emit);
  } else {
    emit();
  }
})();
